import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import { FiCast , FiLayers , FiUsers , FiMonitor ,FiChevronUp, FiCheckCircle , FiServer} from "react-icons/fi";
import ScrollToTop from 'react-scroll-up';
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";


const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Security Strategy',
        description: 'Let us tailor your audits based on a budget schedule.'
    },
    {
        icon: <FiLayers />,
        title: 'Dapp Audit',
        description: 'We identify vulnerabilities in applications interacting with blockchains.'
    },
    {
        icon: <FiUsers />,
        title: 'Smart contract Audit',
        description: "Find and fix vulnerabilities in your smart contract before it's too late. Lead auditor report included."
    },
    {
        icon: <FiMonitor />,
        title: 'Reporting',
        description: 'Show the world you are secure with our report being published on site.'
    },
    {
        icon: <FiCheckCircle />,
        title: 'KYC',
        description: 'Services for founders who want to KYC but not reveal their identity.'
    },
    {
        icon: <FiServer />,
        title: 'Blockchain Security',
        description: 'You have a blockchain or block explorer? We find vulnerabilities and fix them.'
    }
    
]
class Service extends Component{
    render(){
        return(
            <React.Fragment>
                {/* <PageHelmet pageTitle='Service' /> */}
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Service'}   />
                {/* End Breadcrump Area */}

                {/* Start Service Area */}
                <div className="service-area ptb--120 bg_color--5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <h2>Web3 Security </h2>
                                    <p>Need an audit for you web3 project? We are here.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                    <a href="/service-details">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* End Service Area */}





                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />


            </React.Fragment>
        )
    }
}
export default Service;